import React from 'react';
import SmartLink from '../SmartLink/SmartLink';
import { useCart } from '../../context/CartContext';
import { TRUST_ICONS } from './trustIcons';

const ICON_PX = { small: 26, medium: 34, large: 42 };
const inr = n => `₹${Number(n || 0).toLocaleString('en-IN')}`;

// Row of promises under the banner — Admin → Customize → Trust Strip.
// Text can use {freeDeliveryFrom} and {codFee}; they're filled from Admin → Settings so they never go out of date.
const TrustStrip = ({ content }) => {
  const { charges } = useCart();
  const items = content?.items || [];
  if (!content || items.length === 0) return null;

  const fill = text => String(text || '')
    .replace(/\{freeDeliveryFrom\}/g, inr(charges?.freeShippingThreshold))
    .replace(/\{codFee\}/g, inr(charges?.codFee));
  const size = ICON_PX[content.iconSize] || ICON_PX.medium;

  return (
    <section
      className={`trust-strip-section ${content.dividers === false ? 'no-dividers' : ''}`}
      aria-label="Our promises"
      style={{
        '--trust-icon': content.iconColor || 'var(--color-primary)',
        '--trust-title': content.titleColor || 'var(--color-text)',
        '--trust-text': content.textColor || 'var(--color-text-muted)',
        '--trust-bg': content.background || '#FFFFFF',
        '--trust-cols': items.length,
        '--trust-cols-small': Math.min(items.length, 3)
      }}
    >
      <div className="home-container">
        <div className="trust-strip-grid">
          {items.map(item => {
            const Icon = TRUST_ICONS[item.icon] || TRUST_ICONS['delivery-truck'];
            const body = (
              <>
                <div className="trust-icon-box" aria-hidden="true">
                  <Icon width={size} height={size} strokeWidth={1.6} className="trust-strip-svg" />
                </div>
                <div className="trust-text">
                  <p className="trust-title">{fill(item.title)}</p>
                  {item.text && <p>{fill(item.text)}</p>}
                </div>
              </>
            );
            return item.link
              ? <SmartLink key={item.id} to={item.link} className="trust-item trust-item-link">{body}</SmartLink>
              : <div key={item.id} className="trust-item">{body}</div>;
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
